export default __webpack_public_path__ + "static/media/short_icon_black.78cae0a4.svg";